export const PROFILE_DATA = 'profileData';
export const SEND_DIRECTIONS = 'sendDirections';

export const CURRENT_GIFT_TABLE = 'CURRENT_GIFT_TABLE';
export const AGENT_STAFF = 'AGENT_STAFF';
export const AGENT_STAFF_TOKEN = 'AGENT_STAFF_TOKEN';

export const SESSION_TOKEN = 'session_token';

export const SEARS_PRODUCT = 'sears-product';
export const TOTAL_GIFT_TABLES = 'total_giftables';
export const TOTAL_GIFT_TABLES_OPEN = 'total_giftables_open';
export const TOTAL_GIFT_TABLES_CLOSED = 'total_giftables_closed';
